import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { LoggedUserData, DashBoard, Chantier } from 'src/app/classes/json-interface';
import { CST_LOCALSTORAGE_VALUE } from 'src/app/classes/const';
import {CUtilit} from '../../classes/utilit';
import {ArmaServServerMethods} from '../../classes/ArmaServServerMethods';

const CST_LOGIN_TYPE = {
  'None': 0,
  'Client': 1,
  'ArmaorUser': 2
};

@Injectable({
  providedIn: 'root'
})
export class LoggedUserService {

  private mCurrentLoggedUser?: LoggedUserData;

  constructor(private mArmaServMethod: ArmaServServerMethods) { }

  /**
   * Recuperer les droit de l'utilisateur enregistrer dans la session du serveur
   */
  public async loadFromServer() {
    this.setLoggedUser((await this.mArmaServMethod.getRightUser()));
  }

  public setLoggedUser(loggedUser: LoggedUserData) {
    console.log('setLoggedUser', loggedUser);
    this.mCurrentLoggedUser = loggedUser;
    this.clearSiteCode();
  }

  public clearSiteCode() {
    sessionStorage.removeItem(CST_LOCALSTORAGE_VALUE.SelectedSiteCode);
  }

  public setSiteCode(chantier: Chantier) {
    sessionStorage.setItem(CST_LOCALSTORAGE_VALUE.SelectedSiteCode, chantier.CODECHANTIER);
  }

  get customerCode(): string {
    if (!this.mCurrentLoggedUser)
      return '';
    return this.mCurrentLoggedUser.CLIENT_CODE;
  }

  get site(): Chantier|undefined {
    return CUtilit.getSelectedSite();
  }

  get siteCode(): string {
    return CUtilit.getSelectedSiteCode();
  }

  get isCustomerConnected(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return this.mCurrentLoggedUser.LOGIN_TYPE == CST_LOGIN_TYPE.Client;
  }

  get isArmaorUserConnected(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return this.mCurrentLoggedUser.LOGIN_TYPE == CST_LOGIN_TYPE.ArmaorUser;
  }

  get isConnected(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return this.mCurrentLoggedUser.LOGIN_TYPE != CST_LOGIN_TYPE.None;
  }
  get rightShowOverview(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightOverview == 1;
  }

  get rightShowWebInput(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightWebInput == 1;
  }

  get rightShowWebSiteFollowup(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightWebSiteFollowup == 1;
  }

  get rightShowOrderList(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightOrderList == 1;
  }

  get RightShowDeliveryList(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightDeliveryList == 1;
  }

  get RightShowCertif(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightCertif == 1;
  }

  get RightShowInvoiceList(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightInvoiceList == 1;
  }

  get RightShowDataList(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightDataList == 1;
  }

  get RightShowSupervisor(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightSupervisor == 1;
  }

  get RightShowStock(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return +this.mCurrentLoggedUser.RightStock == 1;
  }

  get IsSuperAdmin(): boolean {
    if (!this.mCurrentLoggedUser)
      return false;
    return this.mCurrentLoggedUser.IsSuperAdmin;
  }

  get arrayDashBoard(): DashBoard[] {
    if (!this.mCurrentLoggedUser)
      return [];
    return this.mCurrentLoggedUser.Dashboard;
  }

  get classMediumBorder(): any {
    return CUtilit.getNgStyleBorderColor(this.isArmaorUserConnected, this.isCustomerConnected);
  }

  get classBackground(): any {
    return CUtilit.getNgStyleBackgroundColor(this.isArmaorUserConnected, this.isCustomerConnected);
  }

  get styleStrColorCode(): string {
    return this.isCustomerConnected ? CUtilit.getUserSiteColorCode() : CUtilit.getArmaorUserColorCode();
  }

  get classBackgroundColor(): any {
    return {
      'red-background': this.isArmaorUserConnected
    };
  }

  get classesMatTableBorder(): any {
    return {
      'cmat-red-table-border': this.isArmaorUserConnected,
      'cmat-blue-table-border': this.isCustomerConnected
    };
  }
}
